const apiMessageToProductMessage = msg => {
    const formattedMsg = msg.toLowerCase();

    if (formattedMsg.startsWith('entry already exists for id')) {
        return "It looks like you've already entered, please reload this page.";
    }

    switch (formattedMsg) {
        case 'round is not open':
        case 'sweep is not open':
            return "The ITV7 Grand National Sweepstake isn't open for entries yet. Please check back on April 2nd for your chance to win!";

        case 'sweep has closed':
            return 'Entries for the ITV7 Grand National Sweepstake have now closed. Unfortunately, you have missed out this time. Keep an eye on ITV7 for more chances to win!';

        case 'entity already exists':
            return "It looks like you've already entered, please reload this page.";

        case 'the event has started':
            return 'Entries for the ITV7 Grand National Sweepstake have now closed. Unfortunately, you have missed out this time. Keep an eye on ITV7 for more chances to win!';

        case 'internal server error':
        case 'entity not found':
        case 'no sweepdid found in path parameter':
        case 'no customerid found':
        case 'no consumerid found in query string parameters':
        case 'invalid value for consumerid in query string parameters':
        default:
            return "Oops, something's gone wrong. Please try reloading the page.";
    }
};

export default apiMessageToProductMessage;
